import { useTranslation } from "react-i18next";
import { Button, Card, SectionTitle } from "../../ui/index.js";
import { QuestionField, questionRowClass } from "./QuestionField.js";
import type { AnswerForm, FieldValue } from "./sources.js";
import type { QuestionView } from "./types.js";

/**
 * Ответы на вопросы о правилах, найденные в источниках владельца: каждый можно поправить или убрать.
 * Сохраняются вместе с услугами в черновик и подставляются на шаге правил; ненайденные мастер спросит там.
 */
export function DraftAnswers({
  questions,
  form,
  onChange,
  onRemove,
}: {
  questions: readonly QuestionView[];
  form: AnswerForm;
  onChange: (id: string, v: FieldValue) => void;
  onRemove: (id: string) => void;
}) {
  const { t } = useTranslation();
  const shown = questions.filter((q) => form[q.id] !== undefined);
  if (shown.length === 0) return null;
  return (
    <section aria-labelledby="draft-answers-title">
      <SectionTitle>
        <span id="draft-answers-title">{t("onb.sources.answersTitle")}</span>
      </SectionTitle>
      <p className="mb-2 text-sm text-slate-500">{t("onb.sources.answersHint")}</p>
      <Card className="@container space-y-5">
        {shown.map((q) => (
          <div key={q.id} className={questionRowClass}>
            <QuestionField q={q} value={form[q.id]} onChange={(v) => onChange(q.id, v)} fromSources idPrefix="draft" />
            <Button variant="ghost" className="mt-1 px-0 py-1 text-sm @lg:col-start-2 @lg:justify-start" onClick={() => onRemove(q.id)}>
              {t("onb.sources.removeAnswer")}
            </Button>
          </div>
        ))}
      </Card>
    </section>
  );
}
